type BrandIconProps = {
  className?: string;
  size?: number;
};

function baseSvgProps({ className, size = 16 }: BrandIconProps) {
  return {
    className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    "aria-hidden": true,
    focusable: false,
  } as const;
}

export function OpenAIIcon(props: BrandIconProps) {
  return (
    <svg {...baseSvgProps(props)}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 2.5c1.53 0 2.86.77 3.64 1.94a4.43 4.43 0 0 1 4.57 4.44c0 .44-.07.87-.2 1.28a4.45 4.45 0 0 1-2.26 7.75 4.44 4.44 0 0 1-7.23 2.03 4.43 4.43 0 0 1-6.15-1.38 4.43 4.43 0 0 1-2.52-7.1 4.43 4.43 0 0 1 2.51-6.16A4.44 4.44 0 0 1 12 2.5Zm-.98 3.02a2.52 2.52 0 0 0-3.18 2.42v.42l3.93-2.27a2.54 2.54 0 0 0-.75-.57Zm3.23.36A2.52 2.52 0 0 0 12 4.2c-.32 0-.62.06-.9.17l3.94 2.27a2.6 2.6 0 0 0-.79-.76ZM5.6 7.32a2.53 2.53 0 0 0-1.28 3.37l.2.36 3.93-2.27-2.85-1.46Zm12.8 2.04a2.52 2.52 0 0 0-3.05-2l-.39.13v4.53l3.44-2.66ZM5.1 12l-.02.46a2.52 2.52 0 0 0 3.04 2.46l.4-.13V10.2L5.1 12Zm9.88 2.21 2.86 1.47a2.52 2.52 0 0 0 .56-3.99l-.31-.27-4.11 2.37.99.42Zm-5.9-3.42v3.42l2.92 1.69 2.92-1.69v-3.42L12 9.1 9.08 10.8Zm-.1 7.32A2.52 2.52 0 0 0 12 19.8c.32 0 .62-.06.9-.17l-3.94-2.27c-.03.25-.02.5.02.75Zm6.18-2.48-3.93 2.27c.21.24.5.44.83.57a2.52 2.52 0 0 0 3.18-2.42l-.08-.42Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function AnthropicIcon(props: BrandIconProps) {
  return (
    <svg {...baseSvgProps(props)}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.08 4 2.5 20h3.3l1.08-3.22h6.04L13.98 20h3.37L11.76 4H8.08Zm1.9 3.5 1.93 6.18H7.88L9.98 7.5ZM17.58 4h-3.12l5.62 16h3.12L17.58 4Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function DropboxIcon(props: BrandIconProps) {
  return (
    <svg {...baseSvgProps(props)}>
      <path
        fill="currentColor"
        d="M6.25 3.8 2.2 6.42l4.05 2.6 4.05-2.6-4.05-2.62Zm11.5 0-4.05 2.62 4.05 2.6 4.05-2.6-4.05-2.62ZM2.2 11.66l4.05 2.62 4.05-2.62-4.05-2.6-4.05 2.6Zm13.5 0 4.05 2.62 4.05-2.62-4.05-2.6-4.05 2.6Zm-7.55 4.07L12 18.2l3.85-2.47L12 13.24l-3.85 2.49Zm0 2.8L12 21.2l3.85-2.67L12 16.06 8.15 18.53Z"
      />
    </svg>
  );
}

export function ShopifyIcon(props: BrandIconProps) {
  return (
    <svg {...baseSvgProps(props)}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.8 4.5c.55-1.35 1.6-2.2 3.03-2.2 1.65 0 2.75 1.05 3.16 2.87l2.03.62a.9.9 0 0 1 .63.74l1.45 12.94a.9.9 0 0 1-.9 1H5.75a.9.9 0 0 1-.9-.98L6.2 6.56a.9.9 0 0 1 .66-.76l1.94-.6v-.7Zm1.6.7 3.06-.93c-.35-.76-.87-1.14-1.56-1.14-.74 0-1.2.42-1.5 1.07v1Zm-1.8 8.92c.1 1.08.98 2.15 2.75 2.15 1.7 0 2.85-.9 2.85-2.28 0-1.06-.63-1.7-1.9-2.12l-.9-.3c-.62-.2-.9-.42-.9-.78 0-.42.4-.7.96-.7.65 0 .98.32 1.1.82l1.9-.36c-.2-1.1-1.13-2.02-2.9-2.02-1.66 0-2.77.88-2.77 2.2 0 1.03.67 1.7 1.95 2.1l.86.27c.62.2.9.43.9.83 0 .44-.42.73-1.04.73-.7 0-1.18-.34-1.3-.96l-1.86.41Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function GoogleIcon(props: BrandIconProps) {
  return (
    <svg {...baseSvgProps(props)}>
      <path
        fill="currentColor"
        d="M12.2 2.4c2.43 0 4.53.86 6.16 2.48l-2.5 2.5A5.36 5.36 0 0 0 12.2 6c-3.05 0-5.54 2.52-5.54 5.86 0 3.33 2.49 5.86 5.54 5.86 2.74 0 4.6-1.56 4.93-3.82H12v-3.26h8.73c.08.45.12.9.12 1.52 0 5.13-3.43 8.44-8.65 8.44A8.5 8.5 0 0 1 3.55 12 8.5 8.5 0 0 1 12.2 2.4Z"
      />
    </svg>
  );
}

export function MarketplaceFallbackIcon(props: BrandIconProps) {
  return (
    <svg {...baseSvgProps(props)}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 4.5h14a1 1 0 0 1 1 1V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5.5a1 1 0 0 1 1-1Zm2 3v3h3v-3H7Zm5 0v3h5v-3h-5Zm-5 5v3h3v-3H7Zm5 0v3h5v-3h-5Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

const MARKETPLACE_ICONS = {
  anthropic: AnthropicIcon,
  google: GoogleIcon,
  openai: OpenAIIcon,
  shopify: ShopifyIcon,
} as const;

function normalizeMarketplaceId(
  id: string,
): keyof typeof MARKETPLACE_ICONS | null {
  const normalized = id.trim().toLowerCase();
  if (normalized === "shopify-product-export") return "shopify";
  return normalized in MARKETPLACE_ICONS
    ? (normalized as keyof typeof MARKETPLACE_ICONS)
    : null;
}

export function marketplaceIcon(id: string) {
  const key = normalizeMarketplaceId(id);
  return key ? MARKETPLACE_ICONS[key] : MarketplaceFallbackIcon;
}
